<div class="card" [class.mobile]="deviceService.isMobile()">
  <div class="badge warning" *ngIf="course.is.accepting">Оплата не была завершена</div>
  <div class="date">
    <p class="interval">
      {{ course.begin_at | dfnsFormat : 'dd LLL yyyy' }} - {{ course.end_at | dfnsFormat : 'dd LLL yyyy' }}
    </p>
    <p class="classes">
      {{ 'teacher-card.stats.classes' | customLocale }} {{ meetingsCount }}
      <span class="separator"></span>
      <ng-template [ngIf]="weekdaysToString">
        <span class="text">{{ weekdaysToString }}</span>
      </ng-template>
    </p>
  </div>
  <div class="time">
    <p class="interval">{{ course.begin_at | dfnsFormat : 'HH:mm' }} - {{ course.end_at | dfnsFormat : 'HH:mm' }}</p>
    <p class="free-places">{{ 'meetings.wizard.course.free-places' | customLocale }}: {{ course.participants_left }}</p>
  </div>
  <div class="all-classes" (clickOutside)="isShowAllClasses = false">
    <p class="more" (click)="showMore()">{{ 'meetings.wizard.course.see-all' | customLocale }}</p>
    <div class="more-classes" *ngIf="isShowAllClasses">
      <p class="interval">
        {{ course.begin_at | dfnsFormat : 'dd LLL yyyy' }} - {{ course.end_at | dfnsFormat : 'dd LLL yyyy' }}
      </p>
      <p class="class-item" *ngFor="let event of course.events; let idx = index; trackBy: trackByFn">
        {{ weekDayName(event.begin_at) }} {{ event.begin_at | dfnsFormat : 'LLL dd, HH:mm' }} -
        {{ event.end_at | dfnsFormat : 'HH:mm' }}
      </p>
    </div>
  </div>
  <div class="action">
    <on-ui-button class="status" label="Unavailable"></on-ui-button>

    <!--
    <ng-template [ngIf]="course.is.contracted"
                 [ngIfThen]="signedRef"
                 [ngIfElse]="unsignedRef">
    </ng-template>
    -->
  </div>
</div>
<div *ngIf="debug$ | async">
  {{ course.user_service?.options | json }}
</div>
<!--<div *ngIf="debug$ | async">-->
<!--  <pre>course.can = {{ course.can | json }}</pre>-->
<!--  <pre>course.is = {{ course.is | json }}</pre>-->
<!--</div>-->

<ng-template #signedRef>
  <ng-template [ngIf]="course.is.accepting">
    <on-ui-button class="secondary" label="Перейти к оплате"> </on-ui-button>
  </ng-template>
  <ng-template [ngIf]="course.is.accepted">
    <on-ui-button class="primary" label="meetings.wizard.course.sign-in" (click)="goToClassroom()"> </on-ui-button>
  </ng-template>
</ng-template>

<ng-template #unsignedRef>
  <ng-template [ngIf]="course.can.signup" [ngIfThen]="canSignupRef" [ngIfElse]="cannotSignupRef"> </ng-template>
</ng-template>

<ng-template #canSignupRef>
  <on-ui-button
    class="primary outline"
    [state]="btnState"
    [disabled]="btnState === 'progress'"
    [label]="'meetings.wizard.course.choose' | customLocale"
    (click)="selectService()">
  </on-ui-button>
</ng-template>

<ng-template #cannotSignupRef>
  <on-ui-button
    *ngIf="!course.participants_left"
    class="status"
    [label]="'meetings.wizard.course.no-places' | customLocale">
  </on-ui-button>
</ng-template>
